import { getConfig, setConfig } from '@oneclick/react-lemonade-editor';
import { MATH_RENDER_ENGINE_TANGERINE } from 'app/config/configLatex';
import { LANG_ID_LOCAL_STORAGE_KEY } from 'app/services/language.service';
import i18next from 'app/translations/i18n';

export function initializeLemonade({ showLemonadeAiFeedback, user }) {
  const lang = user?.lang_id || localStorage.getItem(LANG_ID_LOCAL_STORAGE_KEY) || i18next.language || 'en';

  setConfig({
    lang,
    debounceTime: 0,
    mathRenderEngine: MATH_RENDER_ENGINE_TANGERINE,
    showSampleAnswer: true,
    showAIFeedbackGenerator: showLemonadeAiFeedback,
    configEditor: {
      answerOptions: {
        imageDefaultSize: {
          height: null,
          width: null,
        },
      },
      questions: {
        imageDefaultSize: {
          height: null,
          width: null,
        },
      },
    },
  });

  getConfig().overwriteTranslationsByLang('pt', { stimulus: 'Enunciado' });
}
